/**
 * Ordered plan options for upgrade dropdowns (WorkspaceDetail, Upgrades).
 * Labels use PLAN_DISPLAY_NAMES so display names stay in sync.
 */
import { PLAN_DISPLAY_NAMES } from "./planDisplay.js";

const ORDERED_PLAN_IDS = [
  "workspace-starter-yearly",
  "workspace-individual-seats-yearly",
  "workspace-individual-seats-monthly",
  "workspace-professional-seats-yearly",
  "workspace-professional-seats-monthly",
  "workspace-team-seats-yearly",
  "workspace-team-seats-monthly",
  "workspace-business-seats-yearly",
  "workspace-business-seats-monthly",
  "workspace-seats-yearly",
  "workspace-enterprise-seats-yearly",
];

/** Options for the Plan select in workspace upgrade forms (sidebar + Upgrades page). */
export const UPGRADE_PLAN_OPTIONS = ORDERED_PLAN_IDS.map((value) => ({
  value,
  label: PLAN_DISPLAY_NAMES[value] ?? value,
}));

/** Options for Workspaces list filter: filter-only rows + upgrade plans (Enterprise first). */
export const FILTER_PLAN_OPTIONS = [
  { value: "", label: "All Workspaces" },
  { value: "all-paid", label: "All Paid" },
  { value: "all-free", label: "All Free" },
  { value: "workspace-enterprise-seats-yearly", label: "Enterprise Yearly" },
  { value: "workspace-business-seats-yearly", label: "Business Yearly" },
  { value: "workspace-business-seats-monthly", label: "Business Monthly" },
  { value: "workspace-seats-yearly", label: "Seats Yearly" },
  { value: "workspace-professional-seats-yearly", label: "Professional Yearly" },
  { value: "workspace-professional-seats-monthly", label: "Professional Monthly" },
  { value: "workspace-team-seats-yearly", label: "Team Yearly" },
  { value: "workspace-team-seats-monthly", label: "Team Monthly" },
  { value: "workspace-individual-seats-yearly", label: "Individual Yearly" },
  { value: "workspace-individual-seats-monthly", label: "Individual Monthly" },
  { value: "workspace-starter-yearly", label: "Starter" },
];
